import Vue from 'vue'
import Router from 'vue-router'
import main from '@/views/main'
import insuremain from '@/views/insurance/main'
import insurance from '@/views/insurance/insure_n'
import insuranceform from '@/views/insurance/insuranceform'

import electric from '@/views/insurance/electric'
import electricform from '@/views/insurance/electric_form'

import motor from '@/views/insurance/motor'
import motorform from '@/views/insurance/motor_form'

import insure_driver from '@/views/insurance/insure_driver'
import insure_driver_form from '@/views/insurance/insure_driver_form'
import student from '@/views/insurance/student'
import student_form from '@/views/insurance/student_form'
import authorize_book from '@/views/insurance/authorize_book'
import confirm_book from '@/views/insurance/confirm_book'
import letter_book from '@/views/insurance/letter_book'
import insure_list from '@/views/insurance/insure_list'
import bank_card from '@/views/insurance/bank_card'
import static_list from '@/views/insurance/static_list'
import tb_form from '@/views/insurance/tb_form'
import tb_list from '@/views/insurance/tb_list'
import aggrement from '@/views/insurance/aggrement'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: main,
      redirect: { name: 'insure' },
      children: [
        {
          path: 'insure',
          name: 'insure',
          component: insuremain,
          redirect: { name: 'tb' },
          children: [
            {
              path: 'tb',
              name: 'tb',
              component: insurance
            },
            {
              path: 'tbform',
              name: 'tbform',
              component: tb_form,
              meta: {
                keepAlive: true
              }
            },
            {
              path: 'aggrement',
              name: 'aggrement',
              component: aggrement
            },
            {
              path: 'carform',
              name: 'carform',
              component: insuranceform
            },
            {
              path: 'electric',
              name: 'electric',
              component: electric
            },
            {
              path: 'electricform',
              name: 'electricform',
              component: electricform
            },
            {
              path: 'motor',
              name: 'motor',
              component: motor
            },
            {
              path: 'motorform',
              name: 'motorform',
              component: motorform
            },
            {
              path: 'driver',
              name: 'driver',
              component: insure_driver
            },
            {
              path: 'driverform',
              name: 'driverform',
              component: insure_driver_form,
              meta: {
                keepAlive: true
              }
            },
            {
              path: 'student',
              name: 'student',
              component: student
            },
            {
              path: 'studentform',
              name: 'studentform',
              component: student_form,
              meta: {
                keepAlive: true
              }
            },
            {
              path: 'list',
              name: 'insure_list',
              component: insure_list
            },
            {
              path: 'bank_card',
              name: 'bank_card',
              component: bank_card
            },
            {
              path: "tb_list",
              name: "tb_list",
              component: tb_list
            }
          ]
        },
      ]
    },
    {
      path: '/authorize_book',
      name: 'authorize_book',
      component: authorize_book
    },
    {
      path: '/confirm_book',
      name: 'confirm_book',
      component: confirm_book
    },
    {
      path: '/letter_book',
      name: 'letter_book',
      component: letter_book
    },
    {
      path: '/finance',
      name: '',
      component: main,
      redirect: { name: 'finance' },
      children: [{
        path: 'payment',
        name: 'finance',
        component: static_list
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js